"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconSideBarWidget = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _MenuRounded = _interopRequireDefault(require("@material-ui/icons/MenuRounded"));

var _MenuOpenRounded = _interopRequireDefault(require("@material-ui/icons/MenuOpenRounded"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    sandwichWrapper: {
      color: '#FFFFFF',
      '& svg': {
        width: 32,
        height: 32
      }
    }
  };
});

var IconSideBarWidget = function IconSideBarWidget(props) {
  var isOpenSandwich = props.isOpenSandwich,
      sandwichOpenedIcon = props.sandwichOpenedIcon,
      sandwichClosedIcon = props.sandwichClosedIcon,
      onClick = props.onClick,
      hidden = props.hidden,
      className = props.className,
      hide = props.hide;
  var classes = useStyles();

  var _useState = (0, _react.useState)({
    openNavigateMenu: isOpenSandwich
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var toggleDrawer = function toggleDrawer() {
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        openNavigateMenu: !prev.openNavigateMenu
      });
    });
    onClick();
  };

  (0, _react.useEffect)(function () {
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        openNavigateMenu: isOpenSandwich
      });
    });
  }, [isOpenSandwich]);

  if (hide) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(_Hidden.default, hidden, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    edge: "start",
    onClick: function onClick() {
      return toggleDrawer();
    },
    className: (0, _classnames.default)(classes.sandwichWrapper, className),
    "aria-label": state.openNavigateMenu ? 'Fechar Menu' : 'Abrir Menu'
  }, state.openNavigateMenu ? sandwichOpenedIcon : sandwichClosedIcon));
};

exports.IconSideBarWidget = IconSideBarWidget;
IconSideBarWidget.propTypes = {
  /**
   * Se 'TRUE', o estado do menu sandwich é aberto
   */
  isOpenSandwich: _propTypes.default.bool,

  /**
   * Ícone do menu sanduiche enquanto está fechado
   */
  sandwichClosedIcon: _propTypes.default.node,

  /**
   * Ícone do menu sanduiche enquanto está aberto
   */
  sandwichOpenedIcon: _propTypes.default.node,

  /**
   * Função que será executada quando o botão for clicado
   */
  onClick: _propTypes.default.func.isRequired,

  /** Flag de curto-circuito para esconder o widget */
  hide: _propTypes.default.bool,

  /**
   * Propriedades para controlar quando esconder um objeto usa a mesma api do Componente do MUI Hidden
   * {@link https://v4.mui.com/components/hidden/#hidden [Detalhes]}
   */
  hidden: _propTypes.default.shape({
    lgDown: _propTypes.default.bool,
    lgUp: _propTypes.default.bool,
    mdDown: _propTypes.default.bool,
    mdUp: _propTypes.default.bool,
    only: _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])),
    smDown: _propTypes.default.bool,
    smUp: _propTypes.default.bool,
    xlDown: _propTypes.default.bool,
    xlUp: _propTypes.default.bool,
    xsDown: _propTypes.default.bool,
    xsUp: _propTypes.default.bool
  }),

  /** className usado para customizar o componente */
  className: _propTypes.default.string
};
IconSideBarWidget.defaultProps = {
  sandwichClosedIcon: /*#__PURE__*/_react.default.createElement(_MenuRounded.default, null),
  sandwichOpenedIcon: /*#__PURE__*/_react.default.createElement(_MenuOpenRounded.default, null),
  isOpenSandwich: false,
  hide: false,
  hidden: {
    lgDown: false,
    lgUp: false,
    mdDown: false,
    mdUp: false,
    only: null,
    smDown: false,
    smUp: false,
    xlDown: false,
    xlUp: false,
    xsDown: false,
    xsUp: false
  },
  className: ''
};